export const CopyrightAndSocialIconsComponent = {
  template: `<div class="socialIcons">
               <a id="linkedInLink" href="http://www.linkedin.com/company/aptitude-llc">
                 <img class="linkedInIcon" width="42" height="42" src="../images/signInPage/iconsLoginSVG/linkedinIcon.svg" />
               </a>
               <a id="youTubeLink" href="https://www.youtube.com/user/aptitudeLLC">
                 <img class="youTubeIcon" width="42" height="42" src="../images/signInPage/iconsLoginSVG/youtubeIcon.svg" />
               </a>
               <a id="twitterLink" href="https://twitter.com/aptitudellc">
                 <img class="twitterIcon" width="42" height="42" src="../images/signInPage/iconsLoginSVG/twitterIcon.svg" />
               </a>
               <a id="aptitudeLink" href="http://www.aptitude.com/">
                 <img class="aptitudeIcon" width="42" height="42" src="../images/signInPage/iconsLoginSVG/aptitudeIcon.svg" />
               </a>
               <i class="apt-universal-access-icon apt-white fa-3x"
                  data-trigger="click"
                  data-html="true"
                  data-content="<div class='accessibility-support'>
                    <p>For color contrast support please install <b>Midnight Lizard</b>, available for <a href='https://addons.mozilla.org/en-US/firefox/addon/midnight-lizard-quantum/' target='_blank'>FireFox</a> and <a href='https://chrome.google.com/webstore/detail/midnight-lizard/pbnndmlekkboofhnbonilimejonapojg?hl=en' target='_blank'>Chrome</a></p>
                    <p>For color blindness support please install <b>NoCoffee Vision Simulator</b>, available for <a href='https://addons.mozilla.org/en-US/firefox/addon/nocoffee/' target='_blank'>FireFox</a> and <a href='https://chrome.google.com/webstore/detail/nocoffee/jjeeggmbnhckmgdhmgdckeigabjfbddl?hl=en-US' target='_blank'>Chrome</a></p>
                  </div>"
                  data-auto-close="true"
                  data-placement="top" bs-popover></i>
             </div>`,
};
